import type { TreemapChartLegendConfig } from '../types/treemap-chart.config.js';

/**
 * Legend slot component.
 */
export const Legend = (props: TreemapChartLegendConfig) => null;

Legend['displayName'] = 'TreemapChart.Legend';
